







import {Vue, Component} from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import AdminIframe from '@/components/iframe/AdminIframe.vue';

@Component({
  components: {
    PageTitle,
    AdminIframe,
  }
})
export default class ProductMainListIframe extends Vue {
  private get remoteSrc() {
    const url = '/appearance/custom/product-main?';
    const queryObject = { ...this.$route.query, serviceType: 'PREMIUM' };
    const queryString = new URLSearchParams(queryObject).toString();
    const src = process.env.VUE_APP_ADMIN_REMOTE_URL + url + queryString;

    return src;
  }
}
